import { ICommand } from 'core-ts-types';
import MyAppointmentsStateService from '../../services/my_appointment_state_service';

import * as _4 from 'lodash4';
import { AppointmentUsersourceServant } from '../../servants/servants_module';

export interface IAvailableWalkinTimes {
  details: string;
  range: string;
  times: string;
  weekdays: string;
}

export interface IAvailableWalkinTimesUsers {
  name: string;
  times: IAvailableWalkinTimes[];
  currently_available_for_dropins: boolean;
  user_id: number;
}

export interface IAvailableWalkinTimesLocations {
  name: string;
  can_dropin_with_first_available: boolean;
  location_id: number;
  users: IAvailableWalkinTimesUsers[];
}

export class AvailableWalkinTimesController {
  private walkinTimes: IAvailableWalkinTimesLocations[];
  private isLoading: boolean;

  constructor(
    private ngMyAppointmentsStateService: MyAppointmentsStateService,
    private loadAvailableWalkinTimesCommand: ICommand,
    private ngAppointmentUsersourceServant: AppointmentUsersourceServant
  ) {}

  $onInit() {
    this.isLoading = true;
    this.loadAvailableWalkinTimesCommand().then((data: any) => {
      this.walkinTimes = data;
      this.isLoading = false;
      this.ngMyAppointmentsStateService.stateLoaded();
    });
  }

  hasUsers(users: IAvailableWalkinTimesUsers[]) {
    return !_4.isEmpty(users);
  }
}

export class WalkinTimesComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-appointments/src/views/walkin_times/walkin_times.html';
  public controller: any = AvailableWalkinTimesController;
  public controllerAs: string = '$ctrl';
}

angular
  .module('capability-ng-appointments')
  .controller('ngAvailableWalkinTimesController', AvailableWalkinTimesController)
  .component('walkinTimes', new WalkinTimesComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/views/walkin_times/walkin_times.ts